import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

import { user } from "./modules/user";
import { config } from "./modules/config";
import { dashboard } from "./modules/dashboard";
import { course } from "./modules/course";
import { department } from "./modules/department";
import { workshop } from "./modules/workshop";
import { dialog } from "./modules/dialog";
import { news } from "./modules/news";
import { publicApi } from "./modules/public";
import { blogPost } from "./modules/blogPost";
import { sponsor } from "./modules/sponsor";
import { location } from "./modules/location";

export default new Vuex.Store({
  modules: { 
    location,
    sponsor,
    blogPost,
    publicApi,
    news,
    dialog,
    workshop,
    department,
    course,
    dashboard,
    config,
    user,
   }
});
